(function() {
    'use strict';
    angular
        .module('anrescowebApp')
        .factory('SyncQbLog', SyncQbLog);

    SyncQbLog.$inject = ['$resource', 'DateUtils'];

    function SyncQbLog ($resource, DateUtils) {
        var resourceUrl =  'api/sync-qb-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.syncDateTime = DateUtils.convertDateTimeFromServer(data.syncDateTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
